export const getSkills = (state) => state.skills;
